(function(){function g(t,e=document){return e.querySelector(t)}function W(t,e,n,r){const i=n;return t.addEventListener(e,i,r),()=>t.removeEventListener(e,i,r)}function V(t){return{raw:t}}var et="data-html-placeholder";function it(t){return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function bt(t){return typeof t=="object"&&t!==null&&"raw"in t&&typeof t.raw=="string"}function qt(t){if(t==null||t===!1)return"";if(t===!0)return"true";if(typeof t=="string")return it(t);if(typeof t=="number")return it(String(t));if(bt(t))return t.raw;if(t instanceof Node)return t;if(Array.isArray(t)){if(t.every(e=>e instanceof Node)){const e=document.createDocumentFragment();for(const n of t)e.appendChild(n);return e}throw new TypeError("html: arrays of non-Node values are not supported")}throw typeof t=="function"?new TypeError("html: functions are not supported as interpolated values"):new TypeError(`html: unsupported interpolated value of type ${typeof t}`)}function u(t,...e){const n=new Map;let r="";for(let a=0;a<t.length;a++){var i;if(r+=(i=t[a])!==null&&i!==void 0?i:"",a<e.length){const p=qt(e[a]);typeof p=="string"?r+=p:(n.set(a,p),r+=`<template ${et}="${a}"></template>`)}}const c=document.createElement("template");c.innerHTML=r;const o=c.content;return o.querySelectorAll(`template[${et}]`).forEach(a=>{const p=a.getAttribute(et);if(p===null)return;const s=Number(p),f=n.get(s);f!==void 0&&a.replaceWith(f)}),o}var wt="youngle_promo",xe=15;function xt(t){const e=.85*(1-t/100);return Math.floor((1-e)*100)}function K(t,e){return t.replace(/\{\{\s*percent\s*\}\}/g,String(e))}function Ct(){try{return window.sessionStorage.getItem(wt)}catch{return null}}function at(){var t,e,n,r,i,c,o;if(typeof window=="undefined")return null;const a=(t=window.theme)===null||t===void 0?void 0:t.promo;if(a===void 0||typeof a.key!="string"||a.key.length===0)return null;const p=(e=a.discountPercent)!==null&&e!==void 0?e:0;if(p<=0||a.sitewide!==!0&&Ct()!==a.key)return null;const s=(n=a.strings)!==null&&n!==void 0?n:{},f=(r=a.subscriptionDisplayPercent)!==null&&r!==void 0?r:0;return{discountPercent:p,subscriptionDisplayPercent:f>0?f:xt(p),strings:{saveBadge:(i=s.saveBadge)!==null&&i!==void 0?i:"",subscriptionTodayHtml:(c=s.subscriptionTodayHtml)!==null&&c!==void 0?c:"",subscriptionFuture:(o=s.subscriptionFuture)!==null&&o!==void 0?o:""}}}function ct(t,e){return t-Math.floor(t*e.discountPercent/100)}function St(t,e,n){return n===null||t<=0?{priceCents:t,compareCents:e,promoApplied:!1}:{priceCents:ct(t,n),compareCents:Math.max(e,t),promoApplied:!0}}var $t="yqr-spotlight--skeleton",st="yqr-spotlight--revealed",kt=".yqr-spotlight__real-content";function nt(t){if(t.classList.contains(st))return;t.classList.remove($t),t.classList.add(st),t.setAttribute("data-yqr-spotlight-state","ready"),t.removeAttribute("aria-hidden");const e=t.querySelector(kt);e!==null&&e.removeAttribute("hidden")}function lt(t){return t.split(/\n\s*\n/).map(e=>e.trim()).filter(e=>e.length>0)}function Et(t,e,n,r){if(n.replaceChildren(),r.replaceChildren(),t.length>0)for(const i of lt(t)){const c=u`<p class="yqr-spotlight__story-p">${i}</p>`.querySelector("p");c!==null&&n.appendChild(c)}if(e.length===0){r.classList.add("yqr-spotlight__mechanism--hidden");return}r.classList.remove("yqr-spotlight__mechanism--hidden");for(const i of lt(e)){const c=u`<p class="yqr-spotlight__mechanism-p">${i}</p>`.querySelector("p");c!==null&&r.appendChild(c)}}function Pt(t,e){const n=t.trim(),r=e.trim();return n.length===0&&r.length===0?"":n.length>0&&r.length>0?`${n} ${r}`:n||r}function Lt(t,e){if(e.replaceChildren(),t.length!==0)for(const h of t){var n,r,i,c,o,a,p,s,f,d;const y=h.name.trim();if(y.length===0)continue;const q=Pt((n=(r=h.amount_text)===null||r===void 0?void 0:r.trim())!==null&&n!==void 0?n:"",(i=(c=h.unit)===null||c===void 0?void 0:c.trim())!==null&&i!==void 0?i:""),_=(o=(a=h.scientific_name)===null||a===void 0?void 0:a.trim())!==null&&o!==void 0?o:"",E=(p=(s=h.description)===null||s===void 0?void 0:s.trim())!==null&&p!==void 0?p:"",L=(f=(d=h.note)===null||d===void 0?void 0:d.trim())!==null&&f!==void 0?f:"";if(!(E.length>0||_.length>0||L.length>0)){const m=u`<div class="yqr-spotlight__ingredient yqr-spotlight__ingredient--static">
        <div class="yqr-spotlight__ingredient-row">
          <span class="yqr-spotlight__ingredient-name">${y}</span>
          ${q.length>0?u`<span class="yqr-spotlight__ingredient-amount">${q}</span>`:""}
        </div>
      </div>`;e.appendChild(m);continue}const w=[];if(_.length>0){const m=u`<p class="yqr-spotlight__ingredient-scientific">${_}</p>`;w.push(m)}if(E.length>0){const m=u`<p class="yqr-spotlight__ingredient-desc">${E}</p>`;w.push(m)}if(L.length>0){const m=u`<p class="yqr-spotlight__ingredient-note">${L}</p>`;w.push(m)}const T=u`<details class="yqr-spotlight__ingredient">
      <summary>
        <span class="yqr-spotlight__ingredient-name">${y}</span>
        ${q.length>0?u`<span class="yqr-spotlight__ingredient-amount">${q}</span>`:""}
        <span class="yqr-spotlight__ingredient-chevron" aria-hidden="true">&#x25BE;</span>
      </summary>
      <div class="yqr-spotlight__ingredient-body">
        ${w}
      </div>
    </details>`;e.appendChild(T)}}var pt="[YQR-WARN]";function Tt(t,e){e.textContent="",e.classList.add("yqr-spotlight__highlights--hidden");const n=t.length;if(n!==0){if(n===1||n===2){console.warn(pt,"spotlight editorial.highlights should contain 3 to 5 entries; received",n);return}if(n>5){console.warn(pt,"spotlight editorial.highlights should contain at most 5 entries; received",n);return}if(!(n<3)){e.classList.remove("yqr-spotlight__highlights--hidden");for(const r of t){const i=r.trim();if(i.length===0)continue;const c=u`<li class="yqr-spotlight__highlight" role="listitem"><svg class="yqr-spotlight__highlight-icon" viewBox="0 0 82 82" aria-hidden="true"><path d="M28.405 48.928S44.542 23.912 75.372 2.55c2.763-1.915 6.046 1.572 3.979 4.234-13.918 17.921-37.073 49.81-43.093 70.8-.782 2.728-4.346 3.291-5.927.941C25.63 71.543 17 60.565 3.384 49.668c-2.359-1.888-1.617-5.774 1.574-6.211 5.206-.714 13.211-.483 23.447 5.471Z"/></svg>${i}</li>`.querySelector("li");c!==null&&e.appendChild(c)}}}}function At(t){let e=0;for(const n of t)(e===0||n.price<e)&&(e=n.price);return e}function It(t,e,n){return e?n?t.price:0:t.compareAtPrice>t.price?t.compareAtPrice:0}function Mt(t,e,n,r,i,c=!1){var o;const a=At(e.sellingPlans),p=n.length>0&&a>0&&a<e.price,s=St(p?a:e.price,It(e,p,c),i);t.priceFrom.textContent=p?n:"",t.priceFrom.classList.toggle("yqr-spotlight__price-from--hidden",!p),t.price.textContent=r(s.priceCents),t.price.classList.toggle("yqr-spotlight__price--promo",s.promoApplied);const f=(o=t.compare.closest(".yqr-spotlight__compare"))!==null&&o!==void 0?o:t.compare,d=s.compareCents>s.priceCents;t.compare.textContent=d?r(s.compareCents):"",f.classList.toggle("yqr-spotlight__compare--hidden",!d)}function Bt(t,e){let n=null,r=null;const i=()=>{n=null;const o=r;r=null,o&&t(...o)},c=((...o)=>{r=o,n!==null&&clearTimeout(n),n=setTimeout(i,e)});return c.cancel=()=>{n!==null&&(clearTimeout(n),n=null),r=null},c.flush=()=>{n!==null&&(clearTimeout(n),i())},c}var dt=class extends Error{constructor(t,e){super(t),this.name="CartError",this.status=e}},Nt=150,Ot="youngle:cart:changed",Rt={},Dt=Nt,rt,Ft=new Set,ot=null;function zt(){var t;if(rt!==void 0&&rt.length>0)return rt;const e=typeof window!="undefined"?(t=window.Shopify)===null||t===void 0||(t=t.routes)===null||t===void 0?void 0:t.root:void 0;return e!==void 0&&e.length>0?e:"/"}function ut(t){const e=zt();return`${e.endsWith("/")?e:`${e}/`}${t.startsWith("/")?t.slice(1):t}`}async function ft(t,e){if(!t.ok)throw new dt(`Cart request to ${e} failed with status ${t.status}`,t.status);return await t.json()}function Ut(){return ot||(ot=Bt(()=>{for(const e of Ft)e()},Dt)),ot}async function jt(t){var e;const n={id:t.id,quantity:(e=t.quantity)!==null&&e!==void 0?e:1};return t.selling_plan!==void 0&&(n.selling_plan=t.selling_plan),t.properties!==void 0&&(n.properties=t.properties),ft(await fetch(ut("/cart/add.js"),{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(n)}),"/cart/add.js")}async function Ht(t){const e=[];if(t.length===0)return e;let n=!1;for(let r=0;r<t.length;r++){const i=t[r];try{const c=await jt(i);n=!0,e.push({ok:!0,index:r,result:c})}catch(c){if(c instanceof dt)e.push({ok:!1,index:r,error:c});else throw c}}return n&&Gt(),e}async function Wt(){return ft(await fetch(ut("/cart.js"),{method:"GET",credentials:"same-origin",headers:{Accept:"application/json"}}),"/cart.js")}function Gt(){Ut()(),typeof document!="undefined"&&document.dispatchEvent(new CustomEvent(Ot,{detail:{sender:Rt}}))}function mt(t,e){var n;if(typeof window=="undefined")return;const r=(n=window.Shopify)===null||n===void 0?void 0:n.analytics;if(!(r===void 0||typeof r.publish!="function"))try{r.publish(t,e)}catch{}}var Yt="gid://shopify/Product/";function Qt(t){return t.startsWith(Yt)?t.slice(22):t}var b="data-yqr-atc-confirm",yt="yqr-atc-confirm-styles",Jt=class extends Error{constructor(){super("User dismissed the confirmation modal"),this.name="AtcConfirmCancelledError"}},X=null;function Vt(){if(document.getElementById(yt))return;const t=document.createElement("style");t.id=yt,t.textContent=oe,document.head.appendChild(t)}function Kt(){if(X&&X.isConnected)return X;const t=document.createElement("dialog");return t.setAttribute(b,""),document.body.appendChild(t),X=t,t}async function Xt(t){try{const e=await Wt();for(const n of e.items){const r=n.selling_plan_allocation;if(n.variant_id===t&&r!==null&&r!==void 0)return!0}return!1}catch{return!1}}function Zt(t){if(!t.includes("&"))return t;const e=document.createElement("textarea");return e.innerHTML=t,e.value}function k(t,e,n){var r;return Zt((r=t[e])!==null&&r!==void 0?r:n)}function Z(t){var e;const n=document.createElement("template");return n.innerHTML=t,(e=n.content.textContent)!==null&&e!==void 0?e:""}function te(t){const e=/^(.+?[.!?])\s+(\S.*)$/s.exec(t.trim());return e===null?{first:t.trim(),rest:""}:{first:e[1],rest:e[2].trim()}}function ee(t){const e=t.strings,n=te(Z(K(e.subscriptionFuture,15)));return{onetimeBadge:Z(K(e.saveBadge,t.discountPercent)),subscribeBadge:Z(K(e.saveBadge,t.subscriptionDisplayPercent)),subscriptionToday:Z(K(e.subscriptionTodayHtml,t.subscriptionDisplayPercent)),subscriptionFuture:n.first,subscriptionTerms:n.rest}}function gt(t){return t.length>0?u`<span class="yqr-atc-confirm__badge yqr-atc-confirm__badge--promo">${t}</span>`:u``}function ne(t,e,n,r){var i,c,o,a,p,s,f;const d=r===null?null:ee(r),h=t.sellingPlans,y=h[0],q=k(n,"atc_confirm_subscribe_label","Subscribe and save"),_=k(n,"atc_confirm_onetime_label","One-time purchase"),E=k(n,"atc_confirm_cta","Add to cart"),w=(Q=>t.price>0?Math.round((1-Q/t.price)*100):0)(y.price),T=q,m=y.price<t.price,O=m?V("checked"):"",R=m?"":V("checked"),M=t.title;k(n,"atc_confirm_quantity","Quantity");const A=k(n,"atc_confirm_supply_label","One month supply"),S=k(n,"atc_confirm_guarantee","30-day money-back guarantee"),x=k(n,"atc_confirm_subscribe_benefits","Cancel anytime"),B=k(n,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life"),D=w>0?B.replace("{percent}",String(w)):"",I=r!==null&&d!==null&&d.subscriptionToday.length>0&&d.subscriptionFuture.length>0,F=I?"":D,z=`${I&&d.subscriptionTerms.length>0?d.subscriptionTerms:x} · ${S}`,P=/^(.*?)([.!?]?)$/s.exec((i=d==null?void 0:d.subscriptionFuture)!==null&&i!==void 0?i:""),U={body:(c=P==null?void 0:P[1])!==null&&c!==void 0?c:"",punctuation:(o=P==null?void 0:P[2])!==null&&o!==void 0?o:""},G=I?u`<span class="yqr-atc-confirm__promo-breakdown" data-yqr-promo-breakdown>
        <span class="yqr-atc-confirm__promo-line yqr-atc-confirm__promo-line--today">
          <span class="yqr-atc-confirm__promo-text">${d.subscriptionToday}</span>
        </span>
        <span class="yqr-atc-confirm__promo-line">
          <span class="yqr-atc-confirm__promo-text"
            >${U.body} (<span data-yqr-promo-renewal-price
              >${e(y.price)}</span
            >)${U.punctuation}</span
          >
        </span>
      </span>`:u``,j=gt((a=d==null?void 0:d.onetimeBadge)!==null&&a!==void 0?a:""),l=gt((p=d==null?void 0:d.subscribeBadge)!==null&&p!==void 0?p:""),v=k(n,"atc_confirm_recommended","Recommended"),C=h.length>1?u`<select
          class="yqr-atc-confirm__plan-select"
          data-yqr-plan-select
        >
          ${V(h.map(Q=>`<option value="${Q.id}" data-plan-price="${Q.price}" data-plan-name="${Q.name.replace(/"/g,"&quot;")}">${Q.name}</option>`).join(""))}
        </select>`:u`<span class="yqr-atc-confirm__plan-name yg-mono-unit--muted"
          >${y.name}</span
        >`,$=((s=d==null?void 0:d.subscribeBadge)!==null&&s!==void 0?s:"").length>0,N=m&&!$?u`<span class="yqr-atc-confirm__badge">${v}</span>`:u``,Y=m?u`<span class="yqr-atc-confirm__compare-price">${e(t.price)}</span>`:u``,H=(f=t.imageUrl)!==null&&f!==void 0?f:"",J=H.length>0?u`<div class="yqr-atc-confirm__image-col">
        <img
          class="yqr-atc-confirm__image"
          src="${H}"
          alt="${M}"
          loading="eager"
        />
      </div>`:u``;return u`
    <div class="yqr-atc-confirm__body${V(H.length>0?" yqr-atc-confirm__body--has-image":"")}">
      ${J}
      <div class="yqr-atc-confirm__content-col">
      <div class="yqr-atc-confirm__header">
        <h3 class="yqr-atc-confirm__title">${M}</h3>
        <button
          type="button"
          class="yqr-atc-confirm__close"
          data-yqr-confirm-close
          aria-label="Close"
        >\u00d7</button>
      </div>

      <fieldset class="yqr-atc-confirm__options">
        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="onetime"
            data-yqr-plan-choice="onetime"
            ${R}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label">${_}</span>
              ${j}
            </span>
            <span class="yqr-atc-confirm__price-row">
              <span class="yg-display-num--sm"
                >${e(t.price)}</span
              >
            </span>
          </span>
        </label>

        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="subscribe"
            data-yqr-plan-choice="subscribe"
            ${O}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label" data-yqr-subscribe-label
                >${T}</span
              >
              ${N}
              ${l}
            </span>
            <span class="yqr-atc-confirm__savings-for-life" data-yqr-savings-for-life
              >${F}</span
            >
            ${C}
            <span class="yqr-atc-confirm__price-row" data-yqr-subscribe-price>
              <span class="yg-display-num--sm"
                >${e(y.price)}</span
              >
              ${Y}
            </span>
            ${G}
            <span class="yqr-atc-confirm__benefits">${z}</span>
          </span>
        </label>
      </fieldset>

      <p class="yg-mono-unit--muted yqr-atc-confirm__variant">
        ${t.variantTitle} · ${A}
      </p>

      <div class="yqr-atc-confirm__cta-row">
        <div class="yqr-atc-confirm__stepper" data-yqr-quantity-row>
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-minus aria-label="Decrease">\u2212</button>
          <input type="number" class="yqr-atc-confirm__stepper-input" data-yqr-qty-input value="1" min="1" max="9" />
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-plus aria-label="Increase">+</button>
        </div>
        <button
          type="button"
          class="yg-btn yg-btn--red yqr-atc-confirm__cta"
          data-yqr-confirm-cta
        >
          ${E}
        </button>
      </div>
      </div>
    </div>
  `}function re(t,e,n,r={}){return async i=>{if(i.items.length!==1)return t(i);const c=i.items[0],o=e.lookupByVariant(c.variantId);if(!o||o.sellingPlans.length===0||await Xt(c.variantId))return t(i);Vt();const a=Kt();a.classList.remove("yqr-atc-confirm--many-items");const p=o.sellingPlans,s=at();a.innerHTML="",a.appendChild(ne(o,n,r,s));const f=o;return new Promise((d,h)=>{let y=!1;const q=a.querySelector("[data-yqr-confirm-cta]"),_=a.querySelector("[data-yqr-plan-select]"),E=a.querySelector("[data-yqr-subscribe-price]"),L=a.querySelector(".yqr-atc-confirm__option:first-child .yqr-atc-confirm__price-row"),w=a.querySelector("[data-yqr-savings-for-life]"),T=a.querySelector("[data-yqr-promo-renewal-price]"),m=a.querySelector("[data-yqr-qty-input]"),O=a.querySelector("[data-yqr-qty-minus]"),R=a.querySelector("[data-yqr-qty-plus]");function M(l,v,C){if(!l)return;const $=s===null?v:ct(v,s),N=$*C,Y=s===null?"yg-display-num--sm":"yg-display-num--sm yqr-atc-confirm__price--promo",H=C>1?` <span class="yqr-atc-confirm__unit-price">(${C} × ${n($)})</span>`:"",J=$<f.price?` <span class="yqr-atc-confirm__compare-price">${n(f.price*C)}</span>`:"";l.innerHTML=`<span class="${Y}">${n(N)}</span>`+H+J}function A(){if(_){const l=_.selectedOptions[0];if(l)return Number(l.dataset.planPrice)}return p[0].price}function S(){return m?Math.max(1,Math.min(9,Number(m.value)||1)):1}function x(){const l=S(),v=A();M(E,v,l),M(L,f.price,l),T&&(T.textContent=n(v*l))}function B(l){m&&(m.value=String(Math.max(1,Math.min(9,Math.round(l)))),x())}const D=O?W(O,"click",()=>B(S()-1)):null,I=R?W(R,"click",()=>B(S()+1)):null,F=m?W(m,"change",()=>B(S())):null,z=_?W(_,"change",()=>{const l=_.selectedOptions[0];if(!l)return;const v=Number(l.dataset.planPrice),C=f.price>0?Math.round((1-v/f.price)*100):0;x();const $=a.querySelector("[data-yqr-promo-breakdown]")!==null;if(w&&!$){const N=k(r,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life");w.textContent=C>0?N.replace("{percent}",String(C)):""}}):null,P=a.querySelectorAll('input[name="yqr-atc-plan"]'),U=[];for(const l of P)U.push(W(l,"change",x));const G=a.querySelector("[data-yqr-confirm-close]");G&&G.addEventListener("click",()=>{a.close()},{once:!0});const j=W(a,"click",l=>{l.target===a&&a.close()});q&&q.addEventListener("click",()=>{y=!0,a.close()},{once:!0}),a.addEventListener("close",()=>{j(),z&&z(),D&&D(),I&&I(),F&&F();for(const J of U)J();if(!y){h(new Jt);return}const l=a.querySelector('input[name="yqr-atc-plan"]:checked'),v=(l==null?void 0:l.value)==="subscribe";let C=p[0].id;_&&(C=Number(_.value));const $=S(),N=e.lookupByHandle(f.handle),Y=N&&Number(Qt(N.shopifyId))||c.variantId;v?mt("youngle_quiz:atc_confirm_subscribe",{product_id:Y,selling_plan_id:C,quantity:$}):mt("youngle_quiz:atc_confirm_onetime",{product_id:Y,quantity:$});const H={variantId:c.variantId,quantity:$,...v?{sellingPlanId:C}:{}};t({source:i.source,items:[H]}).then(d,h)},{once:!0}),s!==null&&x(),a.showModal()})}}var oe=`
[${b}] {
  border: 0;
  padding: 0;
  max-width: 480px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  background: var(--pure-white, #f8f8f8);
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  /* Desktop: centered modal */
  margin: auto;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

@media (max-width: 719px) {
  [${b}] {
    /* Mobile: bottom-attached drawer */
    margin: auto auto 0 auto;
    inset: auto 0 0 0;
    border-radius: 0;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: 719px) and (max-height: 700px) {
  [${b}] {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
  [${b}] .yqr-atc-confirm__body {
    min-height: 100%;
  }
  [${b}] .yqr-atc-confirm__content-col {
    flex: 1;
  }
  [${b}] .yqr-atc-confirm__cta-row {
    margin-top: auto;
  }
  [${b}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__plan-select,
  [${b}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__benefits {
    display: none;
  }
}

@media (max-width: 719px) {
  [${b}].yqr-atc-confirm--many-items {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
}

[${b}]::backdrop {
  background: rgba(10, 10, 10, 0.45);
}

.yqr-atc-confirm__body {
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: yqrAtcConfirmIn 220ms cubic-bezier(.2,.7,.2,1) both;
}

.yqr-atc-confirm__body::before {
  content: none;
}

.yqr-atc-confirm__image-col {
  display: none;
}

.yqr-atc-confirm__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.yqr-atc-confirm__content-col {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-24, 24px);
  padding: var(--space-24, 24px) var(--gutter-mobile, 20px) calc(var(--space-24, 24px) + env(safe-area-inset-bottom));
}

@media (min-width: 720px) {
  .yqr-atc-confirm__content-col {
    padding: var(--space-32, 32px);
  }

  [${b}]:has(.yqr-atc-confirm__body--has-image) {
    max-width: 520px;
  }

  .yqr-atc-confirm__body--has-image .yqr-atc-confirm__image-col {
    display: none;
  }
}

.yqr-atc-confirm__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--gray-20, #c8c8d0);
  border-radius: 50%;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 160ms ease, background 160ms ease;
}

.yqr-atc-confirm__close:hover,
.yqr-atc-confirm__close:focus-visible {
  border-color: var(--gray-50, #64647a);
  background: var(--gray-05, #f0f0f4);
}

.yqr-atc-confirm__title {
  margin: 0;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  font-weight: 500;
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.yqr-atc-confirm__options {
  border: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__option {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: var(--space-12, 12px);
  cursor: pointer;
  padding: var(--space-16, 16px);
  border-radius: 15px;
  transition: border-color 160ms cubic-bezier(.2,.7,.2,1);
}

.yqr-atc-confirm__option:has(input:checked) {
  border-color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__option input[type="radio"] {
  appearance: none;
  margin: 0;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 2px solid var(--cold-black, #0a0a0a);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  margin-top: 2px;
}

.yqr-atc-confirm__option input[type="radio"]:checked {
  border-color: var(--cold-black, #0a0a0a);
  background: var(--fire-red, #ff4b00);
  box-shadow: inset 0 0 0 3px var(--pure-white, #f8f8f8);
}

.yqr-atc-confirm__option-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__option-label {
  font-weight: 500;
}

.yqr-atc-confirm__plan-select {
  appearance: none;
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-sm, 4px);
  padding: var(--space-8, 8px) var(--space-32, 32px) var(--space-8, 8px) var(--space-12, 12px);
  background: var(--pure-white, #f8f8f8) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%230a0a0a'/%3E%3C/svg%3E") no-repeat right 12px center;
  color: var(--cold-black, #0a0a0a);
  width: 100%;
  max-width: 200px;
  cursor: pointer;
}

.yqr-atc-confirm__price-row {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  flex-wrap: wrap;
}

.yqr-atc-confirm__plan-select + .yqr-atc-confirm__price-row,
.yqr-atc-confirm__plan-name + .yqr-atc-confirm__price-row {
  margin-top: var(--space-8, 8px);
}

.yqr-atc-confirm__variant {
  margin: 0;
}

.yqr-atc-confirm__cta-row {
  display: flex;
  align-items: stretch;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__stepper {
  display: inline-flex;
  align-items: center;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-pill, 999px);
  overflow: hidden;
  flex-shrink: 0;
}

.yqr-atc-confirm__stepper-btn {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-mono, monospace);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

[${b}] .yqr-atc-confirm__stepper-input {
  width: 40px;
  height: 36px;
  border: 0;
  border-left: var(--hairline, 1px solid #e0e0e4);
  border-right: var(--hairline, 1px solid #e0e0e4);
  background: transparent;
  text-align: center;
  font-family: var(--font-mono, monospace);
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  padding: 0;
  margin: 0;
  line-height: 36px;
  -moz-appearance: textfield;
  appearance: textfield;
}

[${b}] .yqr-atc-confirm__stepper-input::-webkit-inner-spin-button,
[${b}] .yqr-atc-confirm__stepper-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.yqr-atc-confirm__unit-price {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__option-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__badge {
  font-family: var(--font-mono, monospace);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--fire-red, #ff4b00);
  color: var(--pure-white, #f8f8f8);
  padding: 2px 8px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

.yqr-atc-confirm__savings-for-life {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
  padding-bottom: var(--space-4, 4px);
}

.yqr-atc-confirm__savings-for-life:empty {
  display: none;
}

.yqr-atc-confirm__price--promo {
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--space-4, 4px);
}

.yqr-atc-confirm__promo-line {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  font-family: var(--font-sans, sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__promo-line::before {
  content: '';
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--cold-black, #0a0a0a);
  transform: translateY(-1px);
}

.yqr-atc-confirm__promo-line--today::before {
  background: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-text {
  flex: 1;
}

[data-yqr-promo-renewal-price] {
  white-space: nowrap;
}

.yqr-atc-confirm__compare-price {
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  color: var(--gray-30, #9494a3);
  text-decoration: line-through;
}

.yqr-atc-confirm__benefits {
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  color: var(--gray-50, #64647a);
  margin-top: var(--space-4, 4px);
}


.yqr-atc-confirm__cta {
  flex: 1;
}

.yqr-atc-confirm__bundle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__bundle-item {
  display: flex;
  align-items: center;
  gap: var(--space-12, 12px);
  font-family: var(--font-sans, sans-serif);
  font-size: 14px;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__bundle-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: var(--radius-sm, 4px);
  flex-shrink: 0;
}

.yqr-atc-confirm__bundle-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__bundle-item-meta {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__savings-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__savings-group .yqr-atc-confirm__savings-for-life {
  padding-bottom: 0;
}

.yqr-atc-confirm__bundle-bonus {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__then-recurring {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

@keyframes yqrAtcConfirmIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .yqr-atc-confirm__option {
    transition: none;
  }
  .yqr-atc-confirm__body {
    animation: none;
  }
}
`;function ie(t,e){const n=t/100,r=ae(n,e);return r!==null?r:ce(n,e.fallbackFormat)}function ae(t,e){try{return typeof Intl=="undefined"||typeof Intl.NumberFormat!="function"?null:new Intl.NumberFormat(e.locale,{style:"currency",currency:e.currency}).format(t)}catch{return null}}function ce(t,e){const n=t.toFixed(2).replace(".",","),r=t.toFixed(2),i=Math.round(t).toString(),c=r.replace("."," ");return e===void 0?r:e.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,n).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,i).replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,c).replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,i).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,i).replace(/\{\{\s*amount\s*\}\}/g,r)}function se(){var t;if(typeof window!="undefined")return(t=window.Shopify)===null||t===void 0?void 0:t.money_format}function le(t){var e;if(typeof window=="undefined")return t;const n=(e=window.Shopify)===null||e===void 0||(e=e.currency)===null||e===void 0?void 0:e.active;return n!==void 0&&n.length>0?n:t}function pe(){if(typeof window!="undefined"){const e=window.cart;if(e!==void 0&&typeof e.getCart=="function"){e.getCart();return}}if(typeof document=="undefined")return;const t=document.querySelector("[data-cart-drawer-toggle]");if(t!==null){t.click();return}document.dispatchEvent(new CustomEvent("cart:open"))}var ht="__youngleCascadeRegistry";function de(){let t=window[ht];return t===void 0&&(t=new Map,window[ht]=t),t}function ue(t,e){const n=de();return n.set(t,e),()=>{n.delete(t)}}var fe="script[data-spotlight-manual-config]",tt=class extends Error{constructor(t){super(t),this.name="ManualConfigError"}};function me(t){var e,n;const r=t.querySelector(fe);if(r===null)throw new tt("Spotlight manual root is missing the JSON config blob");const i=(e=(n=r.textContent)===null||n===void 0?void 0:n.trim())!==null&&e!==void 0?e:"";if(i.length===0)throw new tt("Spotlight manual config blob is empty");try{return JSON.parse(i)}catch{throw new tt("Spotlight manual config blob contains invalid JSON")}}async function ye(t,e,n){var r;const i=`${t}/product-editorial`,c=await fetch(i,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({shopify_ids:[String(e)],locale:n})});if(!c.ok)return console.warn("[spotlight-manual]","Editorial API returned",c.status,c.statusText),null;const o=await c.json();return o.products.length===0?null:(r=o.products[0])!==null&&r!==void 0?r:null}var ge="[data-yqr-spotlight-manual]",_t="data-yqr-spotlight-manual-mounted";function vt(){const t=document.querySelectorAll(ge);if(t.length!==0){for(const e of t)if(!e.hasAttribute(_t)){e.setAttribute(_t,"");try{we(e).catch(n=>{const r=n instanceof Error?n.message:String(n);console.warn("[spotlight-manual]","Mount failed:",r)})}catch(n){if(n instanceof tt){console.warn(`[spotlight-manual] ${n.message}`);continue}throw n}}}}function he(t){const e=le("EUR"),n=se(),r=n!==void 0?{locale:t.locale,currency:e,fallbackFormat:n}:{locale:t.locale,currency:e};return i=>ie(i,r)}function _e(t){return t.available?t.ctaLabelOverride.length>0?t.ctaLabelOverride:t.ctaLabel||"Configure now":t.soldOutLabel||"Sold out"}function ve(t){return{variantId:t.variantId,variantTitle:"",price:t.price,compareAtPrice:t.compareAtPrice,handle:t.handle,title:t.title,url:`/products/${t.handle}`,available:t.available,imageUrl:t.imageUrl,ingredients:"",usage:"",sellingPlans:t.sellingPlans.map(e=>({id:e.id,name:e.name,price:e.price,compareAtPrice:e.compareAtPrice}))}}function be(t,e){return{lookup(n){return(typeof n=="string"?Number(n.replace(/\D/g,"")):n)===t.shopifyId?e:null},lookupByHandle(n){return n===t.handle?{shopifyId:`gid://shopify/Product/${t.shopifyId}`,info:e}:null},lookupByVariant(n){return n===t.variantId?e:null},get size(){return 1}}}async function qe(t){const e=t.items;if(e.length===0)return{requestedLineCount:0,successfulLineCount:0};const n=(await Ht(e.map(r=>{var i;return{id:r.variantId,quantity:(i=r.quantity)!==null&&i!==void 0?i:1,...r.sellingPlanId!==void 0?{selling_plan:r.sellingPlanId}:{}}}))).filter(r=>r.ok).length;return n>0&&pe(),{requestedLineCount:e.length,successfulLineCount:n}}async function we(t){var e,n,r,i,c;const o=me(t),a=he(o);let p=null;try{p=await ye(o.apiBase,o.shopifyId,o.locale)}catch(l){const v=l instanceof Error?l.message:String(l);console.warn("[spotlight-manual]","Editorial fetch failed, rendering without editorial:",v)}const s=(e=p==null?void 0:p.editorial)!==null&&e!==void 0?e:null,f=(n=p==null?void 0:p.ingredients)!==null&&n!==void 0?n:[],d=g("[data-yqr-spotlight-tagline]",t),h=g("[data-yqr-spotlight-title]",t),y=g("[data-yqr-spotlight-dosage]",t),q=g("[data-yqr-spotlight-reason]",t),_=g("[data-yqr-spotlight-story]",t),E=g("[data-yqr-spotlight-mechanism]",t),L=g("[data-yqr-spotlight-ingredients]",t),w=g("[data-yqr-spotlight-highlights]",t),T=g("[data-yqr-spotlight-why]",t),m=g("[data-yqr-product-anchor]",t),O=g("[data-yqr-spotlight-price-from]",t),R=g("[data-yqr-spotlight-price]",t),M=g("[data-yqr-spotlight-compare]",t),A=g("[data-yqr-spotlight-supply-note]",t),S=g("[data-yqr-spotlight-media]",t),x=g("[data-yqr-spotlight-atc]",t);if(d===null||h===null||y===null||q===null||_===null||E===null||L===null||w===null||T===null||m===null||O===null||R===null||M===null||A===null||S===null||x===null){console.warn("[spotlight-manual]","Missing required DOM slots inside spotlight root");return}t.style.setProperty("--yqr-spotlight-accent",o.accentColor),t.setAttribute("data-media-position",o.mediaPosition),m.id=`yqr-product-${o.shopifyId}`,d.textContent=o.tagline||"",h.textContent=o.title;const B=s!==null&&s.dosage_line!==null?s.dosage_line.trim():"";B.length>0?(y.textContent=B,y.classList.remove("yqr-spotlight__dosage--hidden")):(y.textContent="",y.classList.add("yqr-spotlight__dosage--hidden"));const D=o.descriptionOverride.trim(),I=D.length>0?D:o.description.trim();I.length>0?(q.textContent=I,q.classList.remove("yqr-spotlight__reason--hidden")):(q.textContent="",q.classList.add("yqr-spotlight__reason--hidden")),Et(s!==null&&s.story!==null?s.story.trim():"",s!==null&&s.mechanism!==null?s.mechanism.trim():"",_,E),Lt(f,L),Tt(s!==null&&Array.isArray(s.highlights)?s.highlights:[],w),T.replaceChildren(),Mt({priceFrom:O,price:R,compare:M},o,(r=o.priceFromLabel)!==null&&r!==void 0?r:"Ab",a,at());const F=(i=o.supplyNoteLabel)!==null&&i!==void 0?i:"";F.length>0?(A.textContent=F,A.classList.remove("yqr-spotlight__supply-note--hidden")):(A.textContent="",A.classList.add("yqr-spotlight__supply-note--hidden")),S.replaceChildren();const z=o.heroImageUrl.length>0?o.heroImageUrl:o.imageUrl;if(z.length>0){const l=u`<img
      class="yqr-spotlight__image"
      src="${z}"
      alt="${o.title}"
      loading="lazy"
    />`.querySelector("img");l!==null&&S.appendChild(l)}x.textContent=_e(o),x.disabled=!o.available,x.setAttribute("data-variant-id",String(o.variantId));const P=re(qe,be(o,ve(o)),a,(c=o.atcConfirmLabels)!==null&&c!==void 0?c:{}),U=o.variantId,G=o.available,j=x.cloneNode(!0);x.replaceWith(j),j.addEventListener("click",()=>{G&&j.getAttribute("data-yqr-added")!=="true"&&P({source:"spotlight",items:[{variantId:U,quantity:1}]}).catch(l=>{if(l instanceof Error&&l.name==="AtcConfirmCancelledError")return;const v=l instanceof Error?l.message:String(l);console.warn("[spotlight-manual]","Add to cart failed",v)})}),t.hasAttribute("data-yqr-cascade")&&document.querySelector("[data-yqr-video-hero]")!==null?ue(t,()=>nt(t)):nt(t)}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",vt):vt()})();
